import { render, staticRenderFns } from "./LoginOTP.vue?vue&type=template&id=28393de5&scoped=true&"
import script from "./LoginOTP.vue?vue&type=script&lang=js&"
export * from "./LoginOTP.vue?vue&type=script&lang=js&"
import style0 from "./LoginOTP.vue?vue&type=style&index=0&id=28393de5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28393de5",
  null
  
)

export default component.exports